module.exports = __webpack_public_path__ + "static/img/gs7.7b40ca74.jpg";